<template>
  <div>
    <div class="my-4">
      <h3 class="font-bold">Exchange Rates</h3>
      <p>
        The exchange rates displayed for each resource replace the standard 4:1
        trade ratio with the bank for any resource. If a player wants to trade
        with the bank, they must use the exchange rate currently available
        rather than the standard 4:1 rate. For example, if a player has extra
        sheep to trade with the bank and the current sheep exchange rate is 3:1,
        the player would trade 3 sheep with the bank to get 1 resource of their
        choice.
      </p>
      <p>
        The default exchange rate mode is <b>On play turn</b>, which means all
        exchange rates will update on each turn. It is possible the rate for a
        resource may be the same from the turn prior. The other mode of
        <b>Random</b> means each exchange rate will randomly update at random
        intervals.
      </p>
      <p>
        Exchange rates go as low as 2:1 and as high as 6:1. The most common
        exchange rate is 4:1, with the other rates becoming more rare as they
        get lower/higher.
      </p>
    </div>
    <div class="my-4">
      <h3 class="font-bold">Events</h3>
      <p>
        Enable events to add a little Oregon Trail style action to your game!
        For example, when a player rolls the dice for their turn, there is a
        chance an event will be initiated! This event may be positive, such as
        the player being instructed to draw and extra card due to some good
        fortune, or it could be a negative event, such as a player being
        required to discard extra cards.
      </p>
      <p>
        You can customize how often the events happen, with the slider being
        moved toward the left for very rare events, or toward the right for very
        common events.
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style></style>
